import { render, staticRenderFns } from "./AddSubjectModal.vue?vue&type=template&id=7501253e&"
import script from "./AddSubjectModal.vue?vue&type=script&lang=js&"
export * from "./AddSubjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports